import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { SupportAgentTicket } from "@src/types/support";

export const getSupportTicketByIdWithLanguage = async (
  namespace: string,
  ticketId: string,
  language: string,
): Promise<SupportAgentTicket> => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<SupportAgentTicket>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}?language=${language}`,
      { headers },
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch ticket. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while fetching the ticket.");
  }
};
